import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./Footer.scss";
import "../../styles/_common.scss";
import { useForm, SubmitHandler } from "react-hook-form";
import TextField from "components/Inputs/TextField";
import { useAppDispatch, useAppSelector } from "store/store";
import {
  homeSelector,
  addSubscriber,
  clearState,
} from "features/home/home.slice";

import mail from "assets/icons/mail.svg";
import { DirectionCheck } from "../../utils/classnameSwitch";

type Inputs = {
  email: string;
};
const FooterLinks: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { isPending, isSuccess, isError, erroMessage, successMessage } =
    useAppSelector(homeSelector);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<Inputs>();
  const onSubmit: SubmitHandler<Inputs> = (data) => {
    dispatch(addSubscriber(data));
  };
  useEffect(() => {
    if (isError || isSuccess) {
      setTimeout(() => {
        dispatch(clearState());
        reset();
      }, 3000);
    }
  }, [isError, isSuccess, dispatch, reset]);

  const openInNewTab = (event: any, url: string) => {
    event.preventDefault();
    window.open(url);
  };

  return (
    <>
      <div className="container footer-links">
        <div className="columns ">
          <div className="column is-2">
            <div className="titleFooter">{t("footer.about.title")}</div>
            <a href="/about-us">{t("footer.about.whoarewe")}</a>
            <a href="/our-services">{t("footer.about.service")}</a>
            <a href="/offers">{t("footer.about.offers")}</a>
            <a href="/partner-with-us">Partner with us - Agent Membership</a>
          </div>
          <div className="column is-2">
            <div className="titleFooter">{t("footer.help.title")}</div>
            <a href="/contact-us">{t("footer.help.contact")}</a>
          </div>
          <div className="column is-2">
            <div className="titleFooter">{t("footer.policies.title")}</div>
            <a href="/cancellation">{t("footer.policies.cancellation")}</a>
            <a href="/payment-and-refund">{t("footer.policies.payandRef")}</a>
            <a href="/privacy">{t("privacyPolicy.bannerHeading")}</a>
          </div>
          <div
            className={`column social-col is-2 ${
              DirectionCheck() === "rtl" ? "ar-social" : ""
            }`}
          >
            <div className="titleFooter">{t("footer.stayConnected")}</div>
            <div className="socialmedia">
              <a
                href="https://www.facebook.com/Staycae"
                className=" mt-5"
                target="_blank"
                // onClick={(e: any) =>
                //   openInNewTab(e, "https://www.facebook.com/Staycae")
                // }
              >
                <i className="fab fa-facebook"></i>
              </a>
              <a
                href="https://www.instagram.com/staycae.ae/?hl=en"
                className=""
                onClick={(e: any) =>
                  openInNewTab(e, "https://www.instagram.com/staycae.ae/?hl=en")
                }
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://twitter.com/staycaedotae?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
                className=""
                onClick={(e: any) =>
                  openInNewTab(
                    e,
                    "https://twitter.com/staycaedotae?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
                  )
                }
              >
                <i className="fab fa-twitter"></i>
              </a>
            </div>
          </div>

          <div className="column is-4">
            <div className="titleFooter">{t("footer.stayUpdated.title")}</div>
            <div className="footer-email fw-500">
              {t("footer.stayUpdated.enterMail")}
            </div>
            <div>{t("footer.stayUpdated.offer")}</div>
            <div className="control has-icons-left is-flex email-submit mt-4">
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="footer-links-form"
              >
                <TextField
                  label={t("footer.contact.mail")}
                  placeholder={t("footer.stayUpdated.emailPlaceholder")}
                  register={register}
                  name="email"
                  type="email"
                  errors={errors}
                  customError={isError ? erroMessage : ""}
                  rules={{
                    required: true,
                    pattern: /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                  }}
                />
                <span
                  className={`icon is-small ${
                    DirectionCheck() === "rtl" ? "" : "is-left"
                  }`}
                >
                  <img
                    src={mail}
                    alt="The image of an envelope icon"
                    style={{ height: "12px", cursor: "unset" }}
                  />
                </span>
                <button
                  className={`button is-primary submit-btn ${
                    isPending ? "is-loading" : ""
                  }`}
                  type="submit"
                >
                  {t("footer.stayUpdated.submit")}
                </button>
              </form>
              {isSuccess && (
                <span className="footer-links-success-message">
                  {t(successMessage)}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <hr className="hr-footer" />
      <div className="has-text-centered mt-5 has-text-white copyright">
        {t("footer.copyRightText")} {new Date().getFullYear()}{" "}
        {t("footer.copyRight")}
      </div>
    </>
  );
};

export default FooterLinks;
